// extracted by mini-css-extract-plugin
module.exports = {"form_footer":"styles_form_footer__7p3sO","scrollbars":"styles_scrollbars__K6mWp","footerElement":"styles_footerElement__8SNAD","slideInSearchBar":"styles_slideInSearchBar__JCrGV"};